import { render } from "./ActivatePage.vue?vue&type=template&id=04d7a5cc&scoped=true"
import script from "./ActivatePage.vue?vue&type=script&lang=js"
export * from "./ActivatePage.vue?vue&type=script&lang=js"

import "./ActivatePage.vue?vue&type=style&index=0&id=04d7a5cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d7a5cc"]])

export default __exports__